import React, { useEffect } from 'react';
import { DOCUMENT_TITLE_TYPE } from '../data/constants';
import { HomeComponent } from '../features/home-page';
import { setDocumentTitle } from '../helpers/common-helper';

const HomePage = () => {
  useEffect(() => {
    return setDocumentTitle(DOCUMENT_TITLE_TYPE.homepage);
  }, []);

  return <HomeComponent />;
};

export default HomePage;
